<template>
  <div
    class="avatar"
    :class="{ 'avatar--full': full }"
    :style="styles"
    v-bind="$attrs"
  >
    <span>{{ avatar ? "" : initals }}</span>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    id: String,
    avatar: String,
    size: Number,
    full: {
      type: Boolean,
      default: false,
    },
    colors: {
      type: Array,
      default: () => {
        return ["#BECEE0", "#CABAE6", "#CCE8CE", "#FFE78F"];
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    getHash(input) {
      var hash = 0,
        len = input.length;
      for (var i = 0; i < len; i++) {
        hash = (hash << 5) - hash + input.charCodeAt(i);
        hash |= 0; // to 32bit integer
      }
      return Math.abs(hash);
    },
  },
  computed: {
    styles() {
      const size = this.size || 30;
      return {
        backgroundColor: this.color,
        backgroundImage: this.avatar ? `url(${this.avatar})` : "",
        width: size + "px",
        height: size + "px",
        minWidth: size + "px",
        minHeight: size + "px",
        fontSize: (size / 50) * 20 + "px",
      };
    },
    initals() {
      return (this.name || "Anon")
        .split(" ")
        .map((n) => n[0])
        .join("")
        .substr(0, 2)
        .toUpperCase();
    },
    color() {
      return this.colors[this.getHash(this.id) % this.colors.length];
    },
  },
};
</script>

<style scoped lang="scss">
.avatar {
  margin-right: 10px;
  min-width: 30px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75em;

  &--full {
    width: 100% !important;
    height: 100% !important;
    font-size: 24px !important;
  }

  span {
    text-box: trim-both cap alphabetic;
  }
}
</style>
